module.exports = __webpack_public_path__ + "static/img/coinBirth.5b650c0a.png";